export default function ({ context }) {
  const checkEmailUrl = 'https://gb.ru/api/marketing/v1/emails/check'
  const optionsUrl = 'https://pricing.gb.ru/api/pim-education-parameters?filter[id][in]='
  const orderParamsUrl = 'https://orders.gb.ru/api/v2/get-order-params'
  const invoicePayUrl = 'https://orders.gb.ru/api/v2/get-invoice-pay-url'

  return {
    async getUserId(email) {
      try {
        const response = await context.$axios.get(checkEmailUrl, {
          params: { email }
        })

        return response.user_id
      } catch (e) {
        console.warn(e)
      }
    },

    async getOrderData(params) {
      try {
        return await context.$axios.get(`${orderParamsUrl}`, {
          params
        })
      } catch (e) {
        console.warn(e)
      }
    },

    async getAmountByAdditionalOptions(options) {
      if (!options) return 0

      const [diplomaOption, employmentOption] = [940, 941]
      const re = /[а-яa-zА-ЯA-Z[\] ]/g

      try {
        const response = await context.$axios.get(
            `${optionsUrl}${options
                .replaceAll(re, '')
                .split(',')}`
        )

        return response?.reduce(
            (acc, item) =>
                (![diplomaOption, employmentOption].includes(item.id)
                    ? item.value
                    : 0) + acc,
            0
        )
      } catch (e) {
        console.warn(e)
      }
    },

    async getPercentByTempo(tempo) {
      if (!tempo) return 0

      const re = /[а-яa-zА-ЯA-Z[\] ]/g

      try {
        const response = await context.$axios.get(
            `${optionsUrl}${tempo.replaceAll(
                re,
                ''
            )}`
        )

        return response?.[0].value ?? 0
      } catch (e) {
        console.warn(e)
      }
    },

    async getProduct(productId, options, tempo) {
      const defaultPeriods = [6, 10, 12, 18, 24, 36]

      try {
        const response = await context.$axios.get(
            `https://pricing.gb.ru/api/prices/v1/s2/calculate?productIds[]=${productId}&regionIds[]=ru&prices[]=priceWithDiscount`
        )

        const data = response.prices?.[0]

        return {
          productId: data.productId,
          title: data.title,
          price:
              data.prices.find(item => item.type === 'priceWithDiscount')
                  ?.value ?? 0,

          amountOptions: options,
          tempo,

          baseDiscount:
              data.discounts.find(item => item.type === 'baseDiscount')?.value ??
              0,

          additionalFullDiscount:
              data.discounts.find(item => item.type === 'fullPaymentDiscount')
                  ?.value ?? 0,

          periods:
              data.installmentPeriods
                  .filter(({ period, deferredPeriod }) => defaultPeriods.includes(period) && deferredPeriod === 0)
                  .map(item => ({
                    period: item.period,
                    discount: item.value,
                    price: Math.round(
                        item.installments.find(
                            item => item.type === 'monthlyPaymentWithDiscount'
                        )?.monthlyPayment ?? 0
                    )
                  }))
                  .reverse() ?? []
        }
      } catch (e) {
        console.warn(e)
      }
    },

    async getPaymentUrl(paymentData) {
      try {
        const response = await context.$axios.post(`${invoicePayUrl}`, paymentData)

        return {
          url: response?.url,
          ref: response?.invoice_ref
        }
      } catch (e) {
        console.warn(e)
      } finally {
        this.isLoading = false
      }
    }
  }
}
